import type Insured from '@/modules/common/common/models/APP/Insured'
import CommonMapper from '@/modules/core/mappers/CommonMapper'

import ForeignHealthSavePolicyHolderRequest from '@/modules/foreign-health/hiring/models/MID/requests/ForeignHealthSavePolicyHolderRequest'

export default class SavePolicyHolderMapper {
  static toRequest(quotationId: string, holder: Insured): ForeignHealthSavePolicyHolderRequest {
    const dataProtection = {
      dataTransfer: holder.dataTransfer,
      thirdPartyTelephoneAdvertising: holder.thirdPartyTelephoneAdvertising,
      thirdPartyWrittenAdvertising: holder.thirdPartyWrittenAdvertising
    }
    return new ForeignHealthSavePolicyHolderRequest({
      quotationId,
      policyHolder: {
        role: holder.role,
        name: holder.userDetails.name,
        firstSurname: holder.userDetails.surname1,
        secondSurname: holder.userDetails.surname2,
        birthDate: CommonMapper.toMiddlewareDate(holder.userDetails.birthDate),
        sex: holder.userDetails.gender,
        street: holder.addressDetails.address,
        city: holder.addressDetails.city,
        house: holder.addressDetails.roadNumber,
        postalCode: holder.addressDetails.postalCode,
        province: holder.addressDetails.province,
        houseType: holder.addressDetails.houseType,
        gateway: holder.addressDetails.gateway,
        stair: holder.addressDetails.stair,
        floor: holder.addressDetails.floor,
        doorway: holder.addressDetails.doorway,
        restAddres: holder.addressDetails.addressExtra,
        streetType: holder.addressDetails.streetType || 'CALLE',
        email: holder.userDetails.email,
        prefix: holder.userDetails.prefix,
        mobilePhone: holder.userDetails.phone,
        addressNormalice: holder.addressDetails.addressNormalize,
        sendPrecontractualDocuments: holder.preContractualDocumentChecked
      },
      dataProtection: !holder.thirdPartiesAnswered ? dataProtection : undefined
    })
  }
}
